<script lang="ts" setup>
import { setZoomLevel, useLoadingScreen, useWindowScaling } from '@nxtpeople/nxt-styles';
import { useKeycloak } from '@nxtpeople/nxt-vue-keycloak';
import { ModuleKey } from '@nxtpeople/nxt-vue-library';
import { isRenderableRouteComponent } from './core/helpers/route-component.helper';

// #region zoom
// Set default zoom for users that still have the custom zoom level set
setZoomLevel(1);
useWindowScaling(1.25, 0.9);
// #endregion

//#region Loading Screen
const { isPending } = useKeycloak();
const { showLoadingScreen, animationComplete } = useLoadingScreen(isPending);
//#endregion
</script>

<template>
   <div class="app">
      <router-view v-slot="{ Component }">
         <Transition name="fade" mode="out-in">
            <NxtLoadingScreen v-if="showLoadingScreen" :module-key="ModuleKey.NxtPay" @animation-complete="animationComplete = true" />
            <component v-else-if="isRenderableRouteComponent(Component)" :is="Component" />
         </Transition>
      </router-view>
   </div>
</template>

<style src="@nxtpeople/nxt-styles/dist/style.css"></style>

<style lang="scss">
@import '../node_modules/bootstrap/scss/functions';
@import '../node_modules/bootstrap/scss/variables';
@import '../node_modules/bootstrap/scss/variables-dark';
@import '../node_modules/bootstrap/scss/maps';
@import '../node_modules/bootstrap/scss/mixins';
@import '../node_modules/bootstrap/scss/root';
@import '../node_modules/bootstrap/scss/bootstrap-grid';
@import '../node_modules/bootstrap/scss/bootstrap-utilities';

:root {
   // performance action colors
   --nxt-pay-approve-performances: #b0cdf9;
   --nxt-pay-undo-approve-performances: #ccdffc;
   --nxt-pay-process-performances: #bbf3e3;
   --nxt-pay-undo-process-performances: #ddf9f1;
   --nxt-pay-edit-ep-correction-number: #ffe48b;
   --nxt-pay-perform-correction: #ffe48b;
   --nxt-pay-undo-correction: #fff1c1;
   --nxt-pay-process-correction: #bbf3e3;
   --nxt-pay-cancel-correction: #ffd6e0;

   //contract state colors
   --nxt-pay-confirmed-green: #92eed4;
   --nxt-pay-confirmed-green-highlight: #92eed4;
   --nxt-pay-approved-blue-highlight: #b0cdf9;
   --nxt-pay-active: #fae5ff;
   --nxt-pay-processing-green: #92eed4;
   --nxt-pay-ready-to-pay-green: #92eed4;
   --nxt-pay-approved-blue: #b0cdf9;
   --nxt-pay-paid-green: #00c28a;
   --nxt-pay-processing-error: #ffa0b1;

   --nxt-pay-open: #fae5ff;
   --nxt-pay-approved: #b0cdf9;
   --nxt-pay-create-in-progress: #d1d5de;
   --nxt-pay-in-progress: #baedbf;
   --nxt-pay-ready-to-pay: #bbf3e3;
   --nxt-pay-cancelation-in-progress: #d1d5de;
   --nxt-pay-reopened: #fae5ff;
   --nxt-pay-reopened-after-payment: #fae5ff;
   --nxt-pay-remuneration-in-progress: #d1d5de;
   --nxt-pay-control-in-progress: #d1d5de;
   --nxt-pay-paid: #00c28a;
   --nxt-pay-correction-in-progress: #d1d5de;
   --nxt-pay-corrected: #92eed4;
   --nxt-pay-error-processing: #ffd6e0;
   --nxt-pay-rollback-in-progress: #d1d5de;
   --nxt-pay-processed: #bbf3e3;
   --nxt-pay-processed-in-file: #bbf3e3;
   --nxt-pay-processed-in-import-file: #bbf3e3;
}

.app {
   height: 100vh;
}
</style>
